export default __webpack_public_path__ + "static/media/app-str.2a689c61.svg";